export type SalonHistoricalData = {
  id: string;
  cyHistoricalData: CyHistoricalDataValues;
  kpi: SalonHistoricalKPI;
};

export type HistoricalKpi = {
  tnArtists: QuaterlyKpiValues;
  tnServiceSales: QuaterlyKpiValues;
  tnServiceTransactions: QuaterlyKpiValues;
  tnRetailTransactions: QuaterlyKpiValues;
};

export type CyHistoricalDataValues = HistoricalKpi & {
  annualMode: HistoricalDataValues;
  annualInputMode: boolean;
  year: string;
  id: string;
};

export type QuaterlyKpiValues = {
  q1: number;
  q2: number;
  q3: number;
  q4: number;
};

export type HistoricalDataValues = {
  [key: string]: number;
};

type HistoricalKpiValues = {
  value: string;
  prefix: string;
  suffix: string;
};

export type SalonHistoricalKPI = {
  tnArtists: HistoricalKpiValues;
  tnTransactionsBmrk: HistoricalKpiValues;
};

export enum SalonHistoricalKpiMameMap {
  tnTransactionsBmrk = '# OF TRANSACTIONS',
  spRetention = 'SERVICE PROVIDER RETENTION',
}

export const SalonHistoricalQuarterFormMap = {
  staff: [
    {
      label: 'Total # of service providers Q1',
      id: 'tnSpQ1',
    },
    {
      label: 'Total # of service providers Q4',
      id: 'tnSpQ4',
    },
  ],
  service: [
    {
      label: 'Total # of service transactions Q1',
      id: 'tnServiceTransactionsQ1',
    },
    {
      label: 'Total # of service transactions Q2',
      id: 'tnServiceTransactionsQ2',
    },
    {
      label: 'Total # of service transactions Q3',
      id: 'tnServiceTransactionsQ3',
    },
    {
      label: 'Total # of service transactions Q4',
      id: 'tnServiceTransactionsQ4',
    },
  ],
  transactions: [
    {
      label: 'Total # of retail only transactions Q1',
      id: 'tnRetailTransactionsQ1',
    },
    {
      label: 'Total # of retail only transactions Q2',
      id: 'tnRetailTransactionsQ2',
    },
    {
      label: 'Total # of retail only transactions Q3',
      id: 'tnRetailTransactionsQ3',
    },
    {
      label: 'Total # of retail only transactions Q4',
      id: 'tnRetailTransactionsQ4',
    },
  ],
};

export const SalonHistoricalAnnualFormMap = {
  staff: [
    {
      label: 'Total # of service providers (at the beginning of the year)',
      id: 'tnSpBeginning',
    },
    {
      label: 'Total # of service providers (at the end of the year)',
      id: 'tnSpEnd',
    },
  ],
  service: [
    {
      label: 'Total # of service transactions',
      id: 'tnServiceTransactions',
    },
  ],
  transactions: [
    {
      label: 'Total # of retail only transactions',
      id: 'tnRetailTransactions',
    },
  ],
};
